
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Workorder, User, UsersApi } from 'performo-api';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    performoUser: 'performoUser',
    usersApi: 'usersApi'
  })
})
export default class StartStopTimer extends Vue {
  private usersApi!: UsersApi;
  private currentPropertyId!: string;
  private performoUser!: User;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private user!: User;
  private durationDisplay!: string;

  data() {
    // this lets the undefined order!, photo! refs become reactive
    // https://class-component.vuejs.org/guide/class-component.html#data
    return {
      durationDisplay: undefined
    };
  }

  @Watch('durationDisplay', { immediate: true })
  private durationDisplayHandler() {
    setTimeout(() => {
      if (
        this.performoUser &&
        this.performoUser.orderTimer &&
        this.performoUser.orderTimer.timerStarted
      ) {
        // used from: https://stackoverflow.com/a/39590924/86860

        const diffInSeconds =
          Math.abs(
            this.performoUser.orderTimer.timerStarted.valueOf() -
              new Date().valueOf()
          ) / 1000;
        //const days = Math.floor(diffInSeconds / 60 / 60 / 24);
        const hours = Math.floor((diffInSeconds / 60 / 60) % 24);
        const minutes = Math.floor((diffInSeconds / 60) % 60);
        const seconds = Math.floor(diffInSeconds % 60);
        //const milliseconds = Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);

        // since every time we change this value, we set a new setTimeout call
        //this.durationDisplay = `${hours.toLocaleString('en', { minimumIntegerDigits: 2 })}:${minutes.toLocaleString('en', { minimumIntegerDigits: 2 })}:${seconds.toLocaleString('en', { minimumIntegerDigits: 2 })}`;
        let dur = `${minutes.toLocaleString('en', {
          minimumIntegerDigits: 2
        })}:${seconds.toLocaleString('en', { minimumIntegerDigits: 2 })}`;
        if (hours > 0) {
          dur = `${hours.toLocaleString('en', {
            minimumIntegerDigits: 2
          })}:${minutes.toLocaleString('en', {
            minimumIntegerDigits: 2
          })}:${seconds.toLocaleString('en', { minimumIntegerDigits: 2 })}`;
        }

        this.durationDisplay = dur;
      } else {
        // change the string every time through.
        if (!this.durationDisplay) {
          this.durationDisplay = 'Starting';
        }
        const count =
          this.durationDisplay.lastIndexOf('.') -
          this.durationDisplay.indexOf('.');
        if (count == -1) {
          this.durationDisplay = 'Starting' + '.';
        } else if (count == 0) {
          this.durationDisplay = 'Starting' + '..';
        } else if (count == 1) {
          this.durationDisplay = 'Starting' + '...';
        } else {
          this.durationDisplay = 'Starting';
        }
      }
    }, 1000);
  }

  async startTimer() {
    if (!this.performoUser.orderTimer) {
      const userStartedTimer = await this.usersApi.startLaborTimer({
        startLaborTimerCommand: {
          userId: this.performoUser.userId,
          timerStartDateTime: new Date(),
          workorder: { workorderId: this.order.workorderId }
        }
      });

      this.$store.commit('setPerformoUser', userStartedTimer);
    } else {
      // `You have already started labor timer on the following other order(s): ${}. Stop timer on these other orders and start new timer?`
      if (
        confirm(
          `You have already started labor timer on the following other order(s): ${this.performoUser.orderTimer?.workorderId}. Stop timer on these other orders and start new timer?`
        )
      ) {
        // stop current/existing timer
        const userStoppedTimer = await this.usersApi.stopLaborTimer({
          stopLaborTimerCommand: {
            userId: this.performoUser.userId,
            timerEndDateTime: new Date(),
            workorder: {
              workorderId: this.performoUser.orderTimer?.workorderId
            }
          }
        });
        if (!userStoppedTimer) {
          return;
        }
        // start timer on selected order
        const userStartedTimer = await this.usersApi.startLaborTimer({
          startLaborTimerCommand: {
            userId: this.performoUser.userId,
            timerStartDateTime: new Date(),
            workorder: { workorderId: this.order.workorderId }
          }
        });
        // update the store
        this.$store.commit('setPerformoUser', userStartedTimer);
      } else {
        // take no further action
      }
    }
  }

  async stopTimer(ev: MouseEvent) {
    if (ev.ctrlKey) {
      this.gotoOrder();
      return;
    }

    if (this.performoUser.orderTimer?.workorderId == this.order.workorderId) {
      const userStoppedTimer = await this.usersApi.stopLaborTimer({
        stopLaborTimerCommand: {
          userId: this.performoUser.userId,
          timerEndDateTime: new Date(),
          workorder: { workorderId: this.order.workorderId }
        }
      });
      this.$emit('timer-stopped');
      this.$store.commit('setPerformoUser', userStoppedTimer);
    } else {
      alert('You have a timer open on another order.');
    }
  }

  private gotoOrder() {
    if (this.performoUser.orderTimer?.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: this.performoUser.orderTimer?.workorderId }
      });
    }
  }
}
